export function requestResolve(config) {
  //获取token，并将其添加至请求头中
  // const token = localStorage.getItem('token')
  // if (token && token !== '') config.headers['user-token'] = `${token}`
  return config
}

export function requestReject(error) {
  // 错误抛到业务代码
  // error.data = {}
  // error.data.msg = '服务器异常'

  return Promise.resolve(error)
}
